import { render, staticRenderFns } from "./timebox_status_badge.vue?vue&type=template&id=536accd5"
import script from "./timebox_status_badge.vue?vue&type=script&lang=js"
export * from "./timebox_status_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports